import React, { useEffect, useCallback, useState } from "react";
import location from "../../images/Icons/location.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddress } from "../../redux/slice/address";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";
import PincodeService from "../../Component/PincodeService";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";

export default function Address() {
  const [formMode, setFormMode] = useState("list");
  const dispatch = useDispatch();
  const logout = useLogout();
  const [dataLoading, setDataLoading] = useState(false);
  const { addressData, isError } = useSelector((state) => state.address);
  const [getAddress, setGetAddress] = useState({
    name: "",
    company_name: "",
    gst_number: "",
    pan_number: "",
    company_address: "",
    phone: "",
    email: "",
    type: "",
  });

  const fetchUserProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/customer/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setGetAddress((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        company_name: response.data.data.user_detail?.company_name ?? "",
        gst_number: response.data.data.user_detail?.gst_number ?? "",
        pan_number: response.data.data.user_detail?.pan_number ?? "",
        company_address: response.data.data.user_detail?.company_address ?? "",
        phone: response.data.data.phone ?? "",
        email: response.data.data.email ?? "",
        type: response.data.data.user_detail?.type?.[0]?.id ?? "",
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);


  useEffect(() => {
    const fetchData = async () => {
      if (!isError) {
        setDataLoading(true);
        try {
          await dispatch(fetchAddress(logout));
        } catch (error) {
        } finally {
          setDataLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError, logout]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    company_name: "",
    phone: "",
    gst: "",
    address1: "",
    address2: "",
  });
  const [pincode, setPincode] = useState("");
  const [address, setAddress] = useState({
    city: "",
    state: "",
  });
  const [error, setError] = useState({
    companyError: "",
    phoneError: "",
    gstError: "",
    address1Error: "",
    address2Error: "",
    pincodeError: "",
    cityError: "",
    stateError: "",
  });
  const validateData = () => {
    const newErrors = {};
    if (!formData.company_name) {
      newErrors.companyError = "Company name is required";
    }
    if (
      !formData.phone ||
      formData.phone.length !== 10 ||
      isNaN(formData.phone)
    ) {
      newErrors.phoneError = "Valid phone number is required";
    }
    if (!formData.gst) {
      newErrors.gstError = "Gst number is required";
    }
    if (!formData.address1) {
      newErrors.address1Error = "Address line1 is required";
    }
    if (!formData.address2) {
      newErrors.address2Error = "Address line2 is required";
    }
    if (!pincode) {
      newErrors.pincodeError = "Pinccde is required";
    }
    if (!address.city) {
      newErrors.cityError = "City is required";
    }
    if (!address.state) {
      newErrors.stateError = "State is required";
    }
    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handlePincodeChange = async (event) => {
    const newPincode = event.target.value;
    setPincode(newPincode);

    if (newPincode.length === 6) {
      const data = await PincodeService.getCityAndState(newPincode);
      setError({
        pincodeError: "",
      });
      setAddress({
        city: data ? data.city : "",
        state: data ? data.state : "",
      });
    } else {
      setError({
        pincodeError: "The pincode must be 6 digits",
      });
    }
  };
  const handleAddressChange = (event) => {
    const { name, value } = event.target;
    setAddress({
      ...address,
      [name]: value,
    });
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (event, mode) => {
    event.preventDefault();
    if (validateData()) {
      setLoading(true);
      try {
        let response;
        if (mode === "add") {
          response = await axios.post(
            `${config.apiUrl}/address`,
            {
              company_name: formData.company_name,
              phone: formData.phone,
              gst: formData.gst,
              address_line_one: formData.address1,
              address_line_two: formData.address2,
              pincode: pincode,
              city: address.city,
              state: address.state,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: config.token,
                Accept: "application/json",
              },
            }
          );
        } else if (mode === "edit") {
          response = await axios.put(
            `${config.apiUrl}/address/${formData.id}`,
            {
              company_name: formData.company_name,
              phone: formData.phone,
              gst: formData.gst,
              address_line_one: formData.address1,
              address_line_two: formData.address2,
              pincode: pincode,
              city: address.city,
              state: address.state,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: config.token,
                Accept: "application/json",
              },
            }
          );
        }

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          resetFormData();
          setFormMode("list");
          dispatch(fetchAddress());
        }, 1500);
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    }
  };
  const resetFormData = () => {
    setFormData({
      id: "",
      companyError: "",
      phoneError: "",
      gstError: "",

      company_name: "",
      phone: "",
      gst: "",
      address1: "",
      address2: "",
    });
    setPincode("");
    setAddress({
      city: "",
      state: "",
    });
    setError({
      companyError: "",
      phoneError: "",
      gstError: "",
      address1Error: "",
      address2Error: "",
      pincodeError: "",
      cityError: "",
      stateError: "",
    });
  };
  const handleDelete = async (event, address_id) => {
    event.preventDefault();

    try {
      const response = await axios.delete(
        `${config.apiUrl}/address/${address_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      dispatch(fetchAddress());
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };
  const handleFormMode = (mode, data) => {
    setFormMode(mode);
    resetFormData();

    if (mode === "edit" && data !== null) {
      setFormData({
        id: data.id,
        company_name: data.company_name,
        phone: data.phone,
        gst: data.gst,
        address1: data.address_line_one,
        address2: data.address_line_two,
      });
      setPincode(data.pincode);
      setAddress({
        city: data.city,
        state: data.state,
      });
    }

    if (mode === 'add') {
      setFormData({
        company_name: getAddress.company_name,
        phone: getAddress.phone,
        gst: getAddress.gst_number,
      });
    }
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {dataLoading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={location} alt="icon" />
                    <h5>
                      {formMode === "add"
                        ? "Add Address"
                        : formMode === "edit"
                          ? "Edit Address"
                          : "Saved Address"}
                    </h5>
                  </div>
                  {formMode === "add" || formMode === "edit" ? (
                    <button
                      type="button"
                      className="add-edit-btn"
                      onClick={() => handleFormMode("list", null)}
                    >
                      <i className="bi bi-x-lg"></i>Cancel
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="add-edit-btn"
                      onClick={() => handleFormMode("add", null)}
                    >
                      <i className="bi bi-plus-lg"></i>Add New
                    </button>
                  )}
                </div>
                <p className="order-note">
                  <span>Note - </span>
                  Manage your saved addresses for a faster checkout experience.
                  Add a new address or edit existing ones to ensure accurate and
                  hassle-free deliveries !
                </p>

                {formMode === "add" ? (
                  <form onSubmit={(event) => handleSubmit(event, "add")}>
                    <div className="row g-3">
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="company_name">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="company_name"
                          name="company_name"
                          onChange={handleChange}
                          value={formData.company_name}
                          placeholder="Enter Company Name"
                        />
                        {error.companyError && (
                          <span className="input-error">
                            {error.companyError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="phone">Phone Number</label>
                        <input
                          type="number"
                          className="form-control"
                          id="phone"
                          name="phone"
                          onChange={handleChange}
                          value={formData.phone}
                          placeholder="Enter Phone Number"
                          onWheel={(e) => e.target.blur()}
                        />
                        {error.phoneError && (
                          <span className="input-error">
                            {error.phoneError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="gst">Gst Number</label>
                        <input
                          type="text"
                          className="form-control"
                          id="gst"
                          name="gst"
                          value={formData.gst}
                          onChange={handleChange}
                          placeholder="Enter GST Number"
                        />
                        {error.gstError && (
                          <span className="input-error">{error.gstError}</span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="address1">Address Line 1</label>
                        <input
                          type="text"
                          className="form-control"
                          id="address1"
                          name="address1"
                          onChange={handleChange}
                          value={formData.address1}
                          placeholder="Enter Adress Line 1"
                        />
                        {error.address1Error && (
                          <span className="input-error">
                            {error.address1Error}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="address2">Address Line 2</label>
                        <input
                          type="text"
                          className="form-control"
                          id="address2"
                          name="address2"
                          onChange={handleChange}
                          value={formData.address2}
                          placeholder="Enter Address Line 2"
                        />
                        {error.address2Error && (
                          <span className="input-error">
                            {error.address2Error}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="city">City</label>
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          name="city"
                          value={address.city}
                          onChange={handleAddressChange}
                          placeholder="Enter City"
                        />
                        {error.cityError && (
                          <span className="input-error">{error.cityError}</span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="state">State</label>
                        <input
                          type="text"
                          className="form-control"
                          id="state"
                          name="state"
                          value={address.state}
                          onChange={handleAddressChange}
                          placeholder="Enter State"
                        />
                        {error.stateError && (
                          <span className="input-error">
                            {error.stateError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="pincode">Pin Code</label>
                        <input
                          type="number"
                          className="form-control"
                          id="pincode"
                          name="pincode"
                          value={pincode}
                          onChange={handlePincodeChange}
                          placeholder="Enter Pin Code"
                          onWheel={(e) => e.target.blur()}
                        />
                        {error.pincodeError && (
                          <span className="input-error">
                            {error.pincodeError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-12 text-end">
                        <button
                          type="button"
                          disabled={loading}
                          className="add-edit-btn me-2"
                          title="Reset"
                          onClick={resetFormData}
                        >
                          <i className="bi bi-arrow-clockwise"></i>
                          {loading ? "Reseting" : "Reset"}
                        </button>
                        <button
                          type="submit"
                          disabled={loading}
                          className="submit_btn"
                          title="Submit"
                        >
                          <i className="bi bi-floppy"></i>
                          {loading ? "Submitting" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                ) : formMode === "edit" ? (
                  <form onSubmit={(event) => handleSubmit(event, "edit")}>
                    <div className="row g-3">
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="company_name">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="company_name"
                          name="company_name"
                          value={formData.company_name}
                          onChange={handleChange}
                          placeholder="Enter Company Name"
                        />
                        {error.companyError && (
                          <span className="input-error">
                            {error.companyError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="phone">Phone Number</label>
                        <input
                          type="number"
                          className="form-control"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter Phone Number"
                        />
                        {error.phoneError && (
                          <span className="input-error">
                            {error.phoneError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="gst">Gst Number</label>
                        <input
                          type="text"
                          className="form-control"
                          id="gst"
                          name="gst"
                          value={formData.gst}
                          onChange={handleChange}
                          placeholder="Enter GST Number"
                        />
                        {error.gstError && (
                          <span className="input-error">{error.gstError}</span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="address1">Address Line 1</label>
                        <input
                          type="text"
                          className="form-control"
                          id="address1"
                          name="address1"
                          value={formData.address1}
                          onChange={handleChange}
                          placeholder="Enter Adress Line 1"
                        />
                        {error.address1Error && (
                          <span className="input-error">
                            {error.address1Error}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="address2">Address Line 2</label>
                        <input
                          type="text"
                          className="form-control"
                          id="address2"
                          name="address2"
                          value={formData.address2}
                          onChange={handleChange}
                          placeholder="Enter Address Line 2"
                        />
                        {error.address2Error && (
                          <span className="input-error">
                            {error.address2Error}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="city">City</label>
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          name="city"
                          value={address.city}
                          onChange={handleAddressChange}
                          placeholder="Enter City"
                        />
                        {error.cityError && (
                          <span className="input-error">{error.cityError}</span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="state">State</label>
                        <input
                          type="text"
                          className="form-control"
                          id="state"
                          name="state"
                          value={address.state}
                          onChange={handleAddressChange}
                          placeholder="Enter State"
                        />
                        {error.stateError && (
                          <span className="input-error">
                            {error.stateError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-6 px-2">
                        <label htmlFor="pincode">Pin Code</label>
                        <input
                          type="number"
                          className="form-control"
                          id="pincode"
                          name="pincode"
                          value={pincode}
                          onChange={handlePincodeChange}
                          placeholder="Enter Pin Code"
                        />
                        {error.pincodeError && (
                          <span className="input-error">
                            {error.pincodeError}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-12 text-end">
                        <button
                          type="submit"
                          disabled={loading}
                          className="submit_btn"
                        >
                          <i className="bi bi-floppy"></i>
                          {loading ? "Submitting" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                ) : (
                  <>
                    {addressData.length > 0 ? (
                      <div className="row g-3">
                        {addressData.map((data, index) => {
                          return (
                            <div className="col-lg-4 col-md-6 px-2" key={index}>
                              <div className="address-area px-5">
                                <table className="table chart-table table-bordered m-0">
                                  <tbody>
                                    <tr>
                                      <td>Company Name:</td>
                                      <td>{data.company_name}</td>
                                    </tr>
                                    <tr>
                                      <td>Phone Number:</td>
                                      <td>{data.phone}</td>
                                    </tr>
                                    <tr>
                                      <td>Gst Number:</td>
                                      <td>{data.gst}</td>
                                    </tr>
                                    <tr>
                                      <td>Address Line1:</td>
                                      <td>{data.address_line_one}</td>
                                    </tr>
                                    <tr>
                                      <td>Address Line2:</td>
                                      <td>{data.address_line_two}</td>
                                    </tr>
                                    <tr>
                                      <td>City:</td>
                                      <td>{data.city}</td>
                                    </tr>
                                    <tr>
                                      <td>State:</td>
                                      <td>{data.state}</td>
                                    </tr>
                                    <tr>
                                      <td>Pincode:</td>
                                      <td>{data.pincode}</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div className="address-btn">
                                  <button
                                    className="drop-btn"
                                    id="dropMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </button>
                                  <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropMenuButton"
                                  >
                                    <button
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleFormMode("edit", data)
                                      }
                                    >
                                      <i className="bi bi-pencil-square me-2"></i>
                                      Edit
                                    </button>
                                    <button
                                      className="dropdown-item"
                                      onClick={(event) =>
                                        handleDelete(event, data.id)
                                      }
                                    >
                                      <i className="bi bi-trash3 me-2"></i>
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <NoData />
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
